module.exports = __webpack_public_path__ + "img/full6-min.3e080e28.png";